import useGlobalContext from "./useGlobalContext.js";
import { getInternalMockUrlParams } from "../utils/internal-mock-url-params.js";
const injectTrackingVariablesInURLSearchParams = (searchParams, variables) => {
    for (const key in variables) {
        if (variables.hasOwnProperty(key)) {
            searchParams.set(key, variables[key]);
        }
    }
};
export default function useCreateUrl() {
    const { marketingTrackingVariables, apiPrefix, userAgent, isKnownBot, emkToken, offerInstanceId } = useGlobalContext();
    const createUrl = (url) => {
        const urlObj = new URL(url, "http://x");
        if (userAgent.isBot && !isKnownBot) {
            return urlObj.pathname;
        }
        enhanceURLSearchParams(urlObj.searchParams);
        return urlObj.toString().replace(/^http:\/\/x/, "");
    };
    const createRoutePageUrl = (url) => {
        return `https://www.booking.com${createUrl(url)}`;
    };
    const createUrlWithApiPrefix = (url) => {
        return `${apiPrefix}${createUrl(url)}`;
    };
    const enhanceURLSearchParams = (params) => {
        const internalMockParamsInCurrentUrl = process.env.BUILD_TARGET === "client" ? getInternalMockUrlParamsFromCurrentUrl() : {};
        const paramsToInject = {
            ...internalMockParamsInCurrentUrl
        };
        const selectedCurrency = getSelectedCurrencyFromCurrentUrl();
        if (selectedCurrency) {
            paramsToInject.selected_currency = selectedCurrency;
        }
        if (marketingTrackingVariables?.aid) {
            paramsToInject.aid = marketingTrackingVariables?.aid;
        }
        if (marketingTrackingVariables?.label) {
            paramsToInject.label = marketingTrackingVariables?.label;
        }
        if (marketingTrackingVariables?.adPlat) {
            paramsToInject.adplat = marketingTrackingVariables?.adPlat;
        }
        if (marketingTrackingVariables?.gclid) {
            paramsToInject.gclid = marketingTrackingVariables?.gclid;
        }
        if (marketingTrackingVariables?.gbraid) {
            paramsToInject.gbraid = marketingTrackingVariables?.gbraid;
        }
        if (marketingTrackingVariables?.gclsrc) {
            paramsToInject.gclsrc = marketingTrackingVariables?.gclsrc;
        }
        if (marketingTrackingVariables?.auid) {
            paramsToInject.auid = marketingTrackingVariables?.auid;
        }
        if (marketingTrackingVariables?.externalTracking) {
            paramsToInject["ext-tr"] = marketingTrackingVariables?.externalTracking;
        }
        if (marketingTrackingVariables?.externalSource) {
            paramsToInject["ext-src"] = marketingTrackingVariables?.externalSource;
        }
        if (emkToken) {
            paramsToInject.emk = emkToken;
        }
        if (offerInstanceId) {
            paramsToInject.offerInstanceId = offerInstanceId;
        }
        injectTrackingVariablesInURLSearchParams(params, paramsToInject);
    };
    const getInternalMockUrlParamsFromCurrentUrl = () => {
        return getInternalMockUrlParams(location.search);
    };
    const getSelectedCurrencyFromCurrentUrl = () => {
        if (process.env.BUILD_TARGET !== "client") {
            return null;
        }
        const currentUrlParams = new URLSearchParams(location.search);
        return currentUrlParams.get("selected_currency");
    };
    return { createUrl, createRoutePageUrl, createUrlWithApiPrefix, enhanceURLSearchParams };
}
